import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources, type SupportedLanguage } from "./resources";

export function detectBrowserLanguage(): SupportedLanguage {
  const requested = navigator.languages.length > 0 ? navigator.languages : [navigator.language];
  return requested.some((language) => language.toLowerCase().startsWith("hr")) ? "hr" : "en";
}

void i18n.use(initReactI18next).init({
  resources,
  lng: detectBrowserLanguage(),
  fallbackLng: "en",
  supportedLngs: ["en", "hr"],
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;

